import {
  AdminSingleBrandPicker,
  AdminSingleLocationPicker,
  AdminSpinner,
  Box,
  Button,
  Div,
  ErrorToast,
  H3,
  H5,
  getBrandFooterPrintingMessage,
  lightTheme,
  read,
  store,
  reportError,
} from '@vgrubs/components';
import { FooterMessageResponse } from 'components/src/types/api/brand.types';
import { SimpleBrandEntity } from 'components/src/types/brand.types';
import { SimpleLocationEntity } from 'components/src/types/location.types';
import { useState } from 'react';
import { BrandFooterMessageModal } from '../BrandFooterMessageModal';

export const BrandSettings = () => {
  const [loading, setLoading] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState<SimpleBrandEntity | null>(
    null
  );

  const locationLSNode = 'vgrubs-admin-settings-brands-location';
  const locationFromLS = JSON.parse(read(locationLSNode) as string);

  const [footerMessageModal, setFooterMessageModal] =
    useState<FooterMessageResponse | null>(null);

  const [selectedLocation, setSelectedLocation] =
    useState<SimpleLocationEntity | null>(locationFromLS || null);

  async function getFooterMessage() {
    if (!selectedBrand?.id) {
      return;
    }
    try {
      setLoading(true);

      const { data } = await getBrandFooterPrintingMessage(selectedBrand?.id);
      setFooterMessageModal(data.data);
      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  const handleLocationsSubmit = (l: SimpleLocationEntity) => {
    store(locationLSNode, JSON.stringify(l));
  };

  return (
    <>
      {loading && <AdminSpinner isRootPage />}
      <Div>
        <H3 $m="32px 0" $mSM="20px 0">
          Brand Settings
        </H3>
        <Div $flex $alignCenter $between $gap="48px" $gapSM="8px" $columnSM>
          <Div $width="50%" $widthSM="100%">
            <AdminSingleLocationPicker
              selectedLocation={selectedLocation}
              setSelectedLocation={setSelectedLocation}
              handleSubmit={(l) => handleLocationsSubmit(l)}
            />
          </Div>
          <Div $width="50%" $widthSM="100%">
            <AdminSingleBrandPicker
              selectedLocation={selectedLocation}
              selectedBrand={selectedBrand}
              setSelectedBrand={setSelectedBrand}
              preselectIfEmpty
            />
          </Div>
        </Div>
        <Box $mt="8" $flex $alignCenter $between>
          <H5 $color={lightTheme.primary} $mb="0">
            Printing Settings
          </H5>
          <Button
            $gray
            $selected
            $small
            $w="100px"
            onClick={() => {
              if (selectedBrand) {
                getFooterMessage();
              } else {
                ErrorToast('Brand not selected');
              }
            }}
          >
            Edit
          </Button>
        </Box>

        <BrandFooterMessageModal
          modalIsOpen={!!footerMessageModal}
          closeModal={() => setFooterMessageModal(null)}
          setLoading={setLoading}
          data={footerMessageModal}
          id={selectedBrand?.id || null}
        />
      </Div>
    </>
  );
};
